import React from 'react';
import { Breadcrumb, Grid, Tab, Popup } from "semantic-ui-react";
import { connect } from 'react-redux';
import SiteDetailsTab from "./site-details-tab";
import SiteContactsTab from "./site-contacts-tab";
import SiteMeterTab from "./site-meter-tab";
import HalfHourSiteTab from "./site-hh-tab";
import SupplierInvoices from "./site-supplier-invoices-tab";
import ReactGA from 'react-ga';
import SiteProductionParametersTab from "../ProductionParamneter/site-production-parameters-tab";
import ConsumptionChart from "../../components/charts/custom/consumption-chart";
import MonthlyUtilityChart from "../../components/charts/custom/monthly-utility-chart";
import * as api from "../../api";
import EnvironmentCommentaryTab from '../EnvironmentalCommentary/environment-commentary-tab';
import QsrCommentaryTab from '../qsr-commentary/qsr-commentary-tab';
import { collateUtilityData, collateMeterCountDataAll,defaultUtilities } from "../../helpers/chart-dataset-helpers";
import { Helmet } from "react-helmet";
import * as qs from "query-string";
import { Link, withRouter } from "react-router-dom";
import { translateSiteName } from "../../helpers/data-helpers"
import YearlyDonutChart from "../../components/charts/custom/yearly-donut-chart";
import WasteTab from '../waste/waste-tab';
import {AuthService} from "../../services/auth-service";
import UpdateSiteModel from "./site-updates"
import ServiceManagementTab from '../service-management/service-management-tab';
import { BreadcrumbContext } from '../../components/header/breadcrumbcontext'; // Adjust the path as necessary
import * as moment from "moment";



function mapStateToProps(state) {
    return {

    };
}
class Site extends React.Component {
    static contextType = BreadcrumbContext;

    constructor(props) {

        super(props);
        this.authServices = new AuthService();
        this.stickyRef = React.createRef();
        this.checkSticky = this.checkSticky.bind(this);

        this.state = {
            consumptionData: [],
            costData: [],
            dataCompleteness: {},
            site: {},
            fieldMapping:[],
            params: qs.parse(this.props.location.search),
            siteMeterCount: {},
            hasSustainability : this.authServices.hasRole("Sustainability"),
            hasWaste : this.authServices.hasRole("Waste"),
            isAdmin: false, // Default to false until the check is complete
            activeTabIndex: 0, // Default to the first tab
            isSticky: false

        };

        this.fetchData();
        this.setupPanes();
    }

    checkSticky = () => {
       
        if (this.stickyRef.current) {
            const stickyTop = this.stickyRef.current.getBoundingClientRect().top;
            const isSticky = stickyTop <= 200; // 70px is the top value in stickyGraphStyle
            if (isSticky !== this.state.isSticky) {
                this.setState({ isSticky, shouldHideSecondRow: isSticky });
            }
        }
    };


    componentDidUpdate(prevProps) {
        // Check if the URL's query parameters have changed
        if (this.props.location.search !== prevProps.location.search) {
          //this.handleQueryParamsChange();
          
          this.setState({ params: qs.parse(this.props.location.search) });
          this.fetchData();
        }

      }


      handleChartClick = (e) => {

       
        this.setState({ activeTabIndex : 2 });

      }

      handleInvoiceChartClick = (evt,element) => {
        

       
        this.setState({ activeTabIndex : 4 });

        try
        {
        if (element && element.length > 0) {

            const firstPoint = element[0]._chart.getElementAtEvent(evt)[0];
            const utilityColor = firstPoint._options.borderColor;
        

            const index = firstPoint._index;
            const date = this.state.costData[index].date;


            //rgb(255, 166, 0) --- Electricity
            //rgb(249, 93, 106) --- Gas
            //rgb(47, 75, 124) --- Water

            let utilityType;

            // Determine the utility type based on the color code
            if (utilityColor === "rgb(255, 166, 0)") {
              utilityType = "Electricity";
            } else if (utilityColor === "rgb(249, 93, 106)") {
              utilityType = "Gas";
            } else if (utilityColor === "rgb(47, 75, 124)") {
              utilityType = "Water";
            } else {
              // Handle unknown color
              utilityType = "Unknown"; // or throw an error, or handle differently based on your requirements
            }
            
            const queryParams = new URLSearchParams({
                siteKey : this.state.params.siteKey,
                utility: utilityType.toLowerCase(),
                tab : "supplier-invoices",
                date: moment(date).format("YYYY-MM-DD")

              }).toString();
              const url = `/site?${queryParams}`;

              setTimeout(() => {

                this.props.history.push(url);
                },10 * 60)
            
        }
    }catch(err)
    {
    }

      }

      

    setupPanes = () => {

        if(this.state.params.meterReadMode !== undefined )
    {

        this.panes.push( { menuItem: 'Meter', render: () => <Tab.Pane><SiteMeterTab siteKey={this.state.params.siteKey} siteAddress={translateSiteName(this.state.site)} customerId={this.props.customerId} /></Tab.Pane> })
    }else
    {

        this.panes.push( { menuItem: 'Site Details', render: () => <Tab.Pane><SiteDetailsTab site={this.state.site} customerId={this.props.customerId} fieldMapping={this.state.fieldMapping} /></Tab.Pane> })
        this.panes.push( { menuItem: 'Contacts', render: () => <Tab.Pane><SiteContactsTab siteKey={this.state.params.siteKey} customerId={this.props.customerId} /></Tab.Pane> })
        this.panes.push( { menuItem: 'Meter', render: () => <Tab.Pane><SiteMeterTab siteKey={this.state.params.siteKey} siteAddress={translateSiteName(this.state.site)} customerId={this.props.customerId} /></Tab.Pane> })
        this.panes.push( { menuItem: 'Half Hour Data', render: () => <Tab.Pane><HalfHourSiteTab siteKey={this.state.params.siteKey} customerId={this.props.customerId} /></Tab.Pane> })   
        this.panes.push( { menuItem: 'Supplier Invoices', render: () => <Tab.Pane><SupplierInvoices siteKey={this.state.params.siteKey} customerId={this.props.customerId} trimSiteGraphDates={this.trimSiteGraphDates}  /></Tab.Pane> })   

        this.panes.push( { menuItem: 'Cases', render: () => <Tab.Pane><ServiceManagementTab siteKey={this.state.params.siteKey} customerId={this.props.customerId} caseLabel={translateSiteName(this.state.site)}></ServiceManagementTab></Tab.Pane> })   

        if( (this.state.hasSustainability && this.state.isReadOnly === false) || (this.state.isAdmin && this.props.customerId === 15592))
        {
            this.panes.push( { menuItem: 'Environmental Impact Commentary', render: () => <Tab.Pane><EnvironmentCommentaryTab siteKey={this.state.params.siteKey} customerId={this.props.customerId}  /></Tab.Pane> })
            this.panes.push( { menuItem: 'Building Details', render: () => <Tab.Pane><SiteProductionParametersTab siteKey={this.state.params.siteKey} customerId={this.props.customerId} /></Tab.Pane> })
            this.panes.push(  { menuItem: 'QSR Commentary', render: () => <Tab.Pane ><QsrCommentaryTab siteKey={this.state.params.siteKey} customerId={this.props.customerId} /></Tab.Pane> })
        }

        if(this.state.hasWaste|| (this.state.isAdmin && this.props.customerId === 15592))
        {
            this.panes.push({ menuItem: 'Waste', render: () => <Tab.Pane><WasteTab siteKey={this.state.params.siteKey} customerId={this.props.customerId} /></Tab.Pane> })
        }
    }
    }


    trimSiteGraphDates = (toDate, fromDate) => {
       
     

    
        const trimmedCountData = this.trimGraphData(this.state.initialConsumptionData, toDate, fromDate);
        const trimmedNettCostData = this.trimGraphData(this.state.initialCostData, toDate, fromDate);
        const trimmedInitialDataCompleteness = this.trimGraphData(this.state.initialDataCompleteness, toDate, fromDate);

        
        
        // Update the state with the trimmed data
        this.setState({
            consumptionData: trimmedCountData,
            costData: trimmedNettCostData,
            dataCompleteness : trimmedInitialDataCompleteness
        });
    };

    
trimGraphData = (data, toDate, fromDate) => {
    // Check if data is an array
    if (!Array.isArray(data)) {
        //console.error('Data is not an array:', data);
        return [];
    }

    // Convert toDate and fromDate to Date objects
    const toDateObj = new Date(toDate);
    const fromDateObj = new Date(fromDate);

    // Set the start and end of the months for comparison
    const fromStartOfMonth = new Date(fromDateObj.getFullYear(), fromDateObj.getMonth(), 1);
    const toEndOfMonth = new Date(toDateObj.getFullYear(), toDateObj.getMonth() + 1, 0);

    // Filter the data based on the date range
    const trimmedData = data.filter(entry => {
        const entryDate = new Date(entry.date);
        return entryDate >= fromStartOfMonth && entryDate <= toEndOfMonth;
    });


    return trimmedData;
};

    onTabChange = (e, { activeIndex }) => this.setState({ activeTabIndex: activeIndex });

    determineActiveTabIndex = () => {
        const tabNameToIndex = {
            'site-details': 0, // Assuming 'Site Details' is the first tab
            'contacts': 1,
            'meter': 2,
            'half-hour-data': 3,
            'supplier-invoices': 4,
            // Map other tabs similarly
        };
        const tabQuery = this.state.params.tab; // Assuming this.state.params has been set up to contain the query params
        return tabNameToIndex[tabQuery] || 0; // Default to the first tab if not found
    }

    panes = [];

    render() {

        const stickyGraphStyle = {
            position: 'sticky',
            top: '50px',
            zIndex: 100,
            backgroundColor: 'white',
            padding: '10px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            display: this.state.isSticky ? 'flex' : 'none' // LG Instructions: Initially hide this Grid.Row
        };
        
        return (
            <div className='main-container'>
                <Helmet>
                    <title>Inenco Portal | Sites</title>
                </Helmet>
                <Grid padded stackable columns='equal'>
                    <Grid.Row>
                        <Grid.Column>
                            <Breadcrumb>
                                <Breadcrumb.Section link>
                                    <Link to="/sites">
                                        Sites
                                    </Link>
                                </Breadcrumb.Section>
                                <Breadcrumb.Divider />
                                <Breadcrumb.Section active>{translateSiteName(this.state.site)}</Breadcrumb.Section>
                            </Breadcrumb>
                        </Grid.Column>
                    </Grid.Row>
                    {this.state.params.meterReadMode === undefined &&
                    <>
                    <Grid.Row style={stickyGraphStyle}>
                        
                        <Grid.Column>
                            {!!this.state.siteMeterCount.length > 0 &&

                                <YearlyDonutChart data={this.state.siteMeterCount[0]}
                                    title={"Meters By Utility"}
                                    onElementsClick={(e) => this.handleChartClick(e)}
                                    size={"compress"}
                                    />}
                        </Grid.Column>
                        <Grid.Column>
                            {this.state.consumptionData.length > 0 && <ConsumptionChart data={this.state.consumptionData} 
                                                                                                   onElementsClick={(e,element) => this.handleInvoiceChartClick(e,element)}
                                                                                                   size={"compress"}
                                                                />}
                        </Grid.Column>
                        <Grid.Column>
                            {this.state.costData.length > 0 &&
                                <MonthlyUtilityChart data={this.state.costData} label={"Total Cost (£)"} title={"Monthly Utility Cost"}
                                        onElementsClick={(e,element) => this.handleInvoiceChartClick(e,element)}  size={"compress"}
                                />}
                        </Grid.Column>
                        
                        <Popup content='PLEASE NOTE -  this graph is created based on calculations for expected dates of 
                        invoice delivery to Inenco and upload to our database. Therefore the graph/s may not show the full last 
                        12 months of data-completeness. (e.g. a series line with quarterly supplier billing may be 
                        “missing” up to 3 months backwards from today’s date – this will still be deemed to be 100% data-complete).'  
                        position='left center' 
                        inverted 
                        trigger={
                        <Grid.Column>
                            {!!this.state.dataCompleteness.length > 0 &&
                            
                            <MonthlyUtilityChart data={this.state.dataCompleteness} title={"Data Completeness By Utility"} label={"Percentage Complete (%)"}
                                             onElementsClick={(e,element) => this.handleInvoiceChartClick(e,element)} size={"compress"}
                            />}
                        </Grid.Column>
                        }
                        />
                    </Grid.Row>

                    {!this.state.isSticky && ( <>

                    <Grid.Row>
                        
                        <Grid.Column>
                            {!!this.state.siteMeterCount.length > 0 &&

                                <YearlyDonutChart data={this.state.siteMeterCount[0]}
                                    title={"Meters By Utility"}
                                    onElementsClick={(e) => this.handleChartClick(e)}
                                    
                                    />}
                        </Grid.Column>
                        <Grid.Column>
                            {this.state.consumptionData.length > 0 && <ConsumptionChart data={this.state.consumptionData} 
                                                                                                   onElementsClick={(e,element) => this.handleInvoiceChartClick(e,element)}

                                                                />}
                        </Grid.Column>
                        <Grid.Column>
                            {this.state.costData.length > 0 &&
                                <MonthlyUtilityChart data={this.state.costData} label={"Total Cost (£)"} title={"Monthly Utility Cost"}
                                        onElementsClick={(e,element) => this.handleInvoiceChartClick(e,element)} 
                                />}
                        </Grid.Column>
                        
                        <Popup content='PLEASE NOTE -  this graph is created based on calculations for expected dates of 
                        invoice delivery to Inenco and upload to our database. Therefore the graph/s may not show the full last 
                        12 months of data-completeness. (e.g. a series line with quarterly supplier billing may be 
                        “missing” up to 3 months backwards from today’s date – this will still be deemed to be 100% data-complete).'  
                        position='left center' 
                        inverted 
                        trigger={
                        <Grid.Column>
                            {!!this.state.dataCompleteness.length > 0 &&
                            
                            <MonthlyUtilityChart data={this.state.dataCompleteness} title={"Data Completeness By Utility"} label={"Percentage Complete (%)"}
                                             onElementsClick={(e,element) => this.handleInvoiceChartClick(e,element)}
                            />}
                        </Grid.Column>
                        }
                        />
                    </Grid.Row>
                    </> )}


                    </>
                    }
                      {this.state.params.meterReadMode === undefined &&
                    <Grid.Column>
                   
                   {(this.authServices.getCotsStatus() !== 'none') &&

                   <UpdateSiteModel currentSite={this.state.site}></UpdateSiteModel>
                    } 

                  </Grid.Column>
    }

                    <Grid.Row>
                        <Grid.Column>
                            <div ref={this.stickyRef}  >
                            <Tab panes={this.panes}  activeIndex={this.state.activeTabIndex} onTabChange={this.onTabChange} />
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>



        );
    }

    componentDidMount = () => {
       

        const activeTabIndex = this.determineActiveTabIndex();
                this.setState({ activeTabIndex });
                window.addEventListener('scroll', this.checkSticky);
                setTimeout(this.checkSticky, 100); // Delay to ensure the component is fully rendered

                this.fetchData();
            ReactGA.pageview('sites');

                    // Check if the user is an admin
        this.checkAdminStatus();
        
    };

    checkAdminStatus = async () => {
        const isAdmin = await this.authServices.isUserAdmin();
        this.setState({ isAdmin });
    };

    componentWillUnmount() {
        window.removeEventListener('scroll', this.checkSticky);
     }

    fetchData = () => {
        api.getSitesList(this.props.customerId)
            .then(({ data }) => {
                this.setState({ site: data.find(x => x.siteKey === this.state.params.siteKey) })
                this.context.addBreadcrumb({ title: translateSiteName(this.state.site) , path: '/site?siteKey=' + this.state.params.siteKey });
               

            }
            );

        api.getFieldMapping(this.props.customerId)
        .then(({ data }) => {
          
            this.setState({ fieldMapping: data })
           
        }
        );

        api.getSitesCostConsumption(this.props.customerId, this.state.params.siteKey)
            .then((siteCostConsumption) => {
               
                this.setState({
                    consumptionData: collateUtilityData(siteCostConsumption, "consumption"),
                    costData: collateUtilityData(siteCostConsumption, "cost"),
                    dataCompleteness: collateUtilityData(siteCostConsumption, "dataCompleteness", defaultUtilities, x => (x*100).toFixed(2)),

                  
                    initialConsumptionData: collateUtilityData(siteCostConsumption, "consumption"),
                    initialCostData: collateUtilityData(siteCostConsumption, "cost"),
                    initialDataCompleteness: collateUtilityData(siteCostConsumption, "dataCompleteness", defaultUtilities, x => (x*100).toFixed(2)),


                })});

        api.getMetersCountBySite(this.props.customerId, this.state.params.siteKey)
            .then((metersCount) => {

                this.setState({
                    siteMeterCount: collateMeterCountDataAll(metersCount)

                })
                
            }
            );


    };
}

export default connect(
    mapStateToProps,
)(withRouter(Site));